"use strict";Object.defineProperty(exports, "__esModule", {value: true});// Which number a plain SMS from a chat goes out from, so the channel line
// shows the number the patient will see, whoever is sending.
//
// Keep in sync with determineSendingNumber in
// apps/backend/pkg/bloom/command/blobject_push.go; the cases in
// __tests__/sendingNumber.spec.ts mirror its tests in blobject_push_test.go.



























 const determineSendingNumber = ({ chatTeamKeys, teams, patientOrgKey, orgTeams }) => {
  // 1. The chat's first team with a number, by team key (Go sorts the keys
  // as strings, byte by byte; a Bluid is ASCII, so this order is the same).
  for (const teamKey of [...chatTeamKeys].sort((a, b) => (a < b ? -1 : a > b ? 1 : 0))) {
    const team = teams[teamKey]
    if (!team) return { kind: 'unknown' }
    if (team.PhoneNumber) return { kind: 'team', team }
  }
  // 2. Otherwise the patient's org's only numbered team.
  if (patientOrgKey === undefined) return { kind: 'unknown' }
  if (!patientOrgKey) return { kind: 'shared' }
  if (!orgTeams) return { kind: 'unknown' }
  const numbered = orgTeams.filter(t => t.PhoneNumber)
  if (numbered.length === 1) return { kind: 'team', team: numbered[0] }
  // 3. Otherwise the shared number.
  return { kind: 'shared' }
}; exports.determineSendingNumber = determineSendingNumber
